import { ICONS } from "~/svgicons";
import { defineCustomElement as defineMapyAvatar } from "@mapy/ui-components/dist/components/mapy-avatar";
import { defineCustomElement as defineMapyLoader } from "@mapy/ui-components/dist/components/mapy-loader";
import { defineCustomElement as defineMapyIcon } from "@mapy/ui-components/dist/components/mapy-icon";
import { defineCustomElement as defineMapyToggle } from "@mapy/ui-components/dist/components/mapy-toggle";
import { defineCustomElement as defineMapyMapButton } from "@mapy/ui-components/dist/components/mapy-map-button";
import { defineCustomElement as defineMapyMapToggle } from "@mapy/ui-components/dist/components/mapy-map-toggle";
import { defineCustomElement as defineMapyMapButtonGroup } from "@mapy/ui-components/dist/components/mapy-map-button-group";
import { defineCustomElement as defineMapyRouterButton } from "@mapy/ui-components/dist/components/mapy-router-button";
import { defineCustomElement as defineMapyPubtTypeItem } from "@mapy/ui-components/dist/components/mapy-pubt-type-item";
import { defineCustomElement as defineMapyReviewBadgeNew } from "@mapy/review-components/dist/components/mapy-review-badge-new";
import { defineCustomElement as defineMapyMapmenu } from "@mapy/ui-components/dist/components/mapy-mapmenu";
import { defineCustomElement as defineMapyMapmenuItem } from "@mapy/ui-components/dist/components/mapy-mapmenu-item";
import { defineCustomElement as defineMapyMapmenuTitle } from "@mapy/ui-components/dist/components/mapy-mapmenu-title";
import { defineCustomElement as defineMapyMapmenuDivider } from "@mapy/ui-components/dist/components/mapy-mapmenu-divider";
import { defineCustomElement as defineMapyReviewStars } from "@mapy/review-components/dist/components/mapy-review-stars";
import { defineCustomElement as defineMapyReviewButton } from "@mapy/review-components/dist/components/mapy-review-button";
import { defineCustomElement as defineMapyReviewDialog } from "@mapy/review-components/dist/components/mapy-review-dialog";
import { defineCustomElement as defineMapyReviewBadgeComposedNew } from "@mapy/review-components/dist/components/mapy-review-badge-composed-new";
import { defineCustomElement as defineMapyMapmenuMapset } from "@mapy/ui-components/dist/components/mapy-mapmenu-mapset";
import { defineCustomElement as defineMapyMapmenuMapsetPreview } from "@mapy/ui-components/dist/components/mapy-mapmenu-mapset-preview";
import { defineCustomElement as defineMapyMapmenuMapsetMain } from "@mapy/ui-components/dist/components/mapy-mapmenu-mapset-main";
import { defineCustomElement as defineMapyMapmenuMapsetOptions } from "@mapy/ui-components/dist/components/mapy-mapmenu-mapset-options";
import { defineCustomElement as defineMapyMapmenuMapsetOption } from "@mapy/ui-components/dist/components/mapy-mapmenu-mapset-option";
import { defineCustomElement as defineMapyCheckbox } from "@mapy/ui-components/dist/components/mapy-checkbox";
import { getMobilePromoLink } from "./mobile-promo";

defineMapyAvatar();
defineMapyLoader();
defineMapyIcon();
defineMapyToggle();
defineMapyMapButton();
defineMapyMapToggle();
defineMapyMapButtonGroup();
defineMapyRouterButton();
defineMapyPubtTypeItem();
defineMapyMapmenu();
defineMapyMapmenuItem();
defineMapyMapmenuTitle();
defineMapyMapmenuDivider();
defineMapyReviewStars();
defineMapyReviewButton();
defineMapyReviewBadgeNew();
defineMapyReviewBadgeComposedNew();
defineMapyMapmenuMapset();
defineMapyMapmenuMapsetPreview();
defineMapyMapmenuMapsetMain();
defineMapyMapmenuMapsetOptions();
defineMapyMapmenuMapsetOption();
defineMapyReviewStars();
defineMapyReviewDialog();
defineMapyCheckbox();

interface HTMLElementTagNameMap {
	"a": HTMLAnchorElement;
	"abbr": HTMLElement;
	"address": HTMLElement;
	"area": HTMLAreaElement;
	"article": HTMLElement;
	"aside": HTMLElement;
	"audio": HTMLAudioElement;
	"b": HTMLElement;
	"base": HTMLBaseElement;
	"bdi": HTMLElement;
	"bdo": HTMLElement;
	"blockquote": HTMLQuoteElement;
	"body": HTMLBodyElement;
	"br": HTMLBRElement;
	"button": HTMLButtonElement;
	"canvas": HTMLCanvasElement;
	"caption": HTMLTableCaptionElement;
	"cite": HTMLElement;
	"code": HTMLElement;
	"col": HTMLTableColElement;
	"colgroup": HTMLTableColElement;
	"data": HTMLDataElement;
	"datalist": HTMLDataListElement;
	"dd": HTMLElement;
	"del": HTMLModElement;
	"details": HTMLDetailsElement;
	"dfn": HTMLElement;
	"dialog": HTMLDialogElement;
	"dir": HTMLDirectoryElement;
	"div": HTMLDivElement;
	"dl": HTMLDListElement;
	"dt": HTMLElement;
	"em": HTMLElement;
	"embed": HTMLEmbedElement;
	"fieldset": HTMLFieldSetElement;
	"figcaption": HTMLElement;
	"figure": HTMLElement;
	"font": HTMLFontElement;
	"footer": HTMLElement;
	"form": HTMLFormElement;
	"frame": HTMLFrameElement;
	"frameset": HTMLFrameSetElement;
	"h1": HTMLHeadingElement;
	"h2": HTMLHeadingElement;
	"h3": HTMLHeadingElement;
	"h4": HTMLHeadingElement;
	"h5": HTMLHeadingElement;
	"h6": HTMLHeadingElement;
	"head": HTMLHeadElement;
	"header": HTMLElement;
	"hgroup": HTMLElement;
	"hr": HTMLHRElement;
	"html": HTMLHtmlElement;
	"i": HTMLElement;
	"iframe": HTMLIFrameElement;
	"img": HTMLImageElement;
	"input": HTMLInputElement;
	"ins": HTMLModElement;
	"kbd": HTMLElement;
	"label": HTMLLabelElement;
	"legend": HTMLLegendElement;
	"li": HTMLLIElement;
	"link": HTMLLinkElement;
	"main": HTMLElement;
	"map": HTMLMapElement;
	"mark": HTMLElement;
	"marquee": HTMLMarqueeElement;
	"menu": HTMLMenuElement;
	"meta": HTMLMetaElement;
	"meter": HTMLMeterElement;
	"nav": HTMLElement;
	"noscript": HTMLElement;
	"object": HTMLObjectElement;
	"ol": HTMLOListElement;
	"optgroup": HTMLOptGroupElement;
	"option": HTMLOptionElement;
	"output": HTMLOutputElement;
	"p": HTMLParagraphElement;
	"param": HTMLParamElement;
	"picture": HTMLPictureElement;
	"pre": HTMLPreElement;
	"progress": HTMLProgressElement;
	"q": HTMLQuoteElement;
	"rp": HTMLElement;
	"rt": HTMLElement;
	"ruby": HTMLElement;
	"s": HTMLElement;
	"samp": HTMLElement;
	"script": HTMLScriptElement;
	"section": HTMLElement;
	"select": HTMLSelectElement;
	"slot": HTMLSlotElement;
	"small": HTMLElement;
	"source": HTMLSourceElement;
	"span": HTMLSpanElement;
	"strong": HTMLElement;
	"style": HTMLStyleElement;
	"sub": HTMLElement;
	"summary": HTMLElement;
	"sup": HTMLElement;
	"table": HTMLTableElement;
	"tbody": HTMLTableSectionElement;
	"td": HTMLElement;
	"template": HTMLTemplateElement;
	"textarea": HTMLTextAreaElement;
	"tfoot": HTMLTableSectionElement;
	"th": HTMLElement;
	"thead": HTMLTableSectionElement;
	"time": HTMLTimeElement;
	"title": HTMLTitleElement;
	"tr": HTMLTableRowElement;
	"track": HTMLTrackElement;
	"u": HTMLElement;
	"ul": HTMLUListElement;
	"var": HTMLElement;
	"video": HTMLVideoElement;
	"wbr": HTMLElement;
	"mapy-loader": HTMLMapyLoaderElement;
	"mapy-icon": HTMLMapyIconElement;
	"mapy-icon-path": HTMLMapyIconPathElement;
	"mapy-avatar": HTMLMapyAvatarElement;
	"mapy-toggle": HTMLMapyToggleElement;
	"mapy-map-button": HTMLMapyMapButtonElement;
	"mapy-map-toggle": HTMLMapyMapToggleElement;
	"mapy-map-button-group": HTMLMapyMapButtonGroupElement;
	"mapy-router-button": HTMLMapyRouterButtonElement;
	"mapy-review-badge-new": HTMLMapyReviewBadgeNewElement;
	"mapy-mapmenu": HTMLMapyMapmenuElement;
	"mapy-mapmenu-item": HTMLMapyMapmenuItemElement;
	"mapy-mapmenu-title": HTMLMapyMapmenuTitleElement;
	"mapy-mapmenu-divider": HTMLMapyMapmenuDividerElement;
	"mapy-review-stars": HTMLMapyReviewStarsElement;
	"mapy-review-button": HTMLMapyReviewButtonElement;
	"mapy-review-badge-composed-new": HTMLMapyReviewBadgeComposedNewElement;
	"mapy-mapmenu-mapset": HTMLMapyMapmenuMapsetElement;
	"mapy-mapmenu-mapset-preview": HTMLMapyMapmenuMapsetPreviewElement;
	"mapy-mapmenu-mapset-main": HTMLMapyMapmenuMapsetMainElement;
	"mapy-mapmenu-mapset-options": HTMLMapyMapmenuMapsetOptionsElement;
	"mapy-mapmenu-mapset-option": HTMLMapyMapmenuMapsetOptionElement;
	"mapy-pubt-type-item": HTMLMapyPubtTypeItemElement;
	"mapy-review-dialog": HTMLMapyReviewDialogElement;
	"mapy-checkbox": HTMLMapyCheckboxElement;
}

interface MapyElement {
	command?: string;
	action?: string;
	style?: any;
}

const PREMIUM_ICON_SRC = "/img/premium.svg";

export function fragment(doc: Document = document): DocumentFragment {
	return doc.createDocumentFragment();
}

export function text(txt: string, doc: Document = document): Text {
	return doc.createTextNode(txt);
}

export function node<K extends keyof HTMLElementTagNameMap>(tagName: K, options: Partial<HTMLElementTagNameMap[K] & MapyElement> = {}, content = "", doc: Document = document): HTMLElementTagNameMap[K] {
	const { style, action, command, ...rest } = options;
	const element = doc.createElement(tagName);

	if (style) {
		element.setAttribute("style", style.toString());
	}

	Object.assign(element, rest);

	if (action) {
		element.setAttribute("data-action", action);
	}

	if (command) {
		element.setAttribute("data-command", command);
	}

	if (content) {
		element.appendChild(text(content, doc));
	}

	return element as HTMLElementTagNameMap[K];
}

/**
 * Vytvoří ikonu
 */
export function icon(type = "", title = "", doc: Document = document) {
	const str = ICONS[type];

	if (!str) {
		// eslint-disable-next-line no-console
		console.error("Bad icon type '%s'", type);

		const span = node("span", {}, "🔥", doc);

		span.style.fontSize = "24px";

		return span;
	}

	const tmp = node("div", { innerHTML: str }, undefined, doc);
	const svg = tmp.querySelector("svg");

	svg.classList.add("icon");
	svg.classList.add(`icon-${type}`);

	if (title) {
		const titleElement = doc.createElementNS("http://www.w3.org/2000/svg", "title");

		titleElement.appendChild(text(title, doc));
		svg.appendChild(titleElement);
	}

	return svg;
}

export function createAvatar(url: string, size: number, premium = "none"): DocumentFragment {
	const img = node("img", { src: url ? `${url}/${size}` : "", srcset: url ? `${url}/${size} 1x, ${url}/${size * 2} 2x` : "" });
	const avatar = node("mapy-avatar");
	const icn = icon("lock");
	const cont = document.createDocumentFragment();

	avatar.setAttribute("premium", premium);
	avatar.setAttribute("size", size.toString());
	img.crossOrigin = "anonymous";
	avatar.appendChild(img);
	cont.appendChild(avatar);
	cont.appendChild(icn);

	return cont;
}

// https://gist.github.com/davidtheclark/5515733
export function isInViewport(elem: HTMLElement): boolean {
	const rect = elem.getBoundingClientRect();

	if (rect.width === 0 && rect.height === 0) {
		return false;
	}

	const windowHeight = window.innerHeight || document.documentElement.clientHeight;
	const windowWidth = window.innerWidth || document.documentElement.clientWidth;

	const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
	const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

	return vertInView && horInView;
}

let starIconID = 0;

/**
 * Ikona hvezdicky
 */
export function starIcon() {
	const type = "star2";

	const str = ICONS[type];
	const id = `clip${starIconID}`;
	const tmp = node("div", { innerHTML: str.replace(new RegExp("clip0", "gu"), id) }, undefined, document);
	const svg = tmp.querySelector("svg");

	svg.classList.add("icon");
	svg.classList.add(`icon-${type}`);
	starIconID++;

	return svg;
}

export function buildRadioCheck(type = "checkbox", name = "", innerHTML = "", doc = document) {
	const label = node("label", { className: "radiocheck" }, undefined, doc);
	const input = node("input", { type, name }, undefined, doc);
	const title = node("span", { innerHTML }, undefined, doc);

	label.appendChild(input);
	label.appendChild(title);

	return {
		label: label,
		input: input,
		title: title,
	};
}

export const isFocusable = (item: HTMLElement): boolean => {
	if (item.tabIndex < 0) {
		return false;
	}

	switch (item.tagName) {
		case "A":
			return !!(item as HTMLAnchorElement).href;
		case "INPUT":
			return (item as HTMLInputElement).type !== "hidden" && !(item as HTMLInputElement).disabled;
		case "SELECT":
		case "TEXTAREA":
		case "BUTTON":
			return !(item as HTMLSelectElement | HTMLTextAreaElement | HTMLButtonElement).disabled;
		default:
			return item.tabIndex > -1;
	}
};

export const findFirstFocusableElement = (container: HTMLElement | Document): HTMLElement => (Array.from(container.getElementsByTagName("*")) as Array<HTMLElement>).find(isFocusable);

export function createAppBadge(os: "android" | "iOS", language: string, url: string): HTMLAnchorElement {
	const link = node("a", { className: "ui-app-badge", href: getMobilePromoLink(url), target: "_blank" });

	link.setAttribute("data-log-action", "promo");
	link.setAttribute("data-log-type", `button_promo_${os}_store_download`);
	link.appendChild(node("img", { src: `/img/promo/badge-${os}-${["cs", "sk"].indexOf(language) === -1 ? "en" : "cz"}.svg`, width: 135, height: 40 }));

	return link;
}

export function separateWithElement(array: Array<HTMLElement>, separator: HTMLElement): Array<HTMLElement> {
	const result = [];

	for (let index = 0; index < array.length; index++) {
		result.push(array[index]);

		if (index < array.length - 1) {
			result.push(separator.cloneNode(true));
		}
	}

	return result;
}

export function createPremiumIcon({
	className = "",
	...props
}: Partial<HTMLImageElement> = {}): HTMLImageElement {
	return node("img", {
		src: PREMIUM_ICON_SRC,
		className,
		...props,
	});
}

export function getPremiumIconSrc() {
	return PREMIUM_ICON_SRC;
}

export function stripHtmlElements(html: string) {
	const doc = new DOMParser().parseFromString(html, "text/html");

	return (doc.body.textContent || "").trim();
}
